<template>
  <div class="card flex-grow-1 shadow-sm">
    <div class="card-header">Comparison</div>
    <div class="card-body">
      <div class="comparison-widget">
        <h4>Beeline: {{ beelineCount }}</h4>
        <h4>Ucell: {{ ucellCount }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmsCompanyCountComponent',
  data () {
    return {
      ucellCount: 0,
      beelineCount: 0
    }
  },
  created () {
    this.doRequest()
  },
  methods: {
    doRequest () {
      this.axios.get('dashboard/sms-company-count')
        .then(({data}) => {
          if (data.data) {
            const ucell = Object.keys(data.data).find(item => item.toLowerCase() === 'ucell')
            const beeline = Object.keys(data.data).find(item => item.toLowerCase() === 'beeline')
            if (ucell) {
              this.ucellCount = data.data[ucell]
            }
            if (beeline) {
              this.beelineCount = data.data[beeline]
            }
          }
        }).catch(() => {
          this.$toastr.error('Internal server error')
        })
    }
  }
}
</script>

<style scoped>
.comparison-widget {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/SmsCompanyCountComponent.vue